import { useToast as useToastDesktop } from '@teko/ds-desktop';
import { useToast as useToastMobile } from '@teko/ds-mobile';

const useToastContext = (isMobile?: boolean) => {
  return isMobile ? useToastMobile : useToastDesktop;
};
export const useToast = (isMobile?: boolean) => {
  const hook = useToastContext(isMobile);
  const context = hook();
  if (!context) {
    throw new Error(
      'useToast must be inside a ToastProvider with a showToast value',
    );
  }
  return context;
};
